import {
  AppRoute,
} from '../types/router'

const routes: AppRoute[] = [
  {
    title: 'panNFT',
    name: 'home',
    group: 'home',
    path: '/',
    layout: 'web',
  },
  {
    title: 'panNFT : Bowie',
    name: 'bowie',
    group: 'bowie',
    path: '/bowie',
    layout: 'web',
  },
  {
    title: 'panNFT : Bowie',
    name: 'bowie_pdf',
    group: 'bowie',
    path: '/bowie/pdf',
    layout: 'web',
  },
  {
    title: 'panNFT : Graven',
    name: 'graven_home',
    group: 'graven',
    path: '/graven',
    layout: 'web',
  },
  {
    title: 'panNFT : Graven',
    name: 'graven_image',
    group: 'graven',
    path: '/graven/image/:image',
    layout: 'web',
  },
  {
    title: 'panNFT : 101010',
    name: 'threetens_home',
    path: '/101010',
    layout: 'web',
    group: 'threetens',
  },
  {
    title: 'panNFT : 101010',
    name: 'threetens_gallery',
    path: '/101010/gallery',
    layout: 'web',
    group: 'threetens',
  },
  {
    title: 'panNFT : 101010',
    name: 'threetens_token',
    path: '/101010/token/:token',
    layout: 'web',
    group: 'threetens',
  },
  {
    title: 'panNFT : Godpixel',
    name: 'godpixel_home',
    path: '/godpixel',
    layout: 'web',
    group: 'godpixel',
  },
  {
    title: 'panNFT : Godpixel',
    name: 'godpixel_pdf',
    path: '/godpixel/:id',
    layout: 'web',
    group: 'godpixel',
  },
  {
    title: 'panNFT : Impressum',
    name: 'impressum',
    path: '/impressum',
    layout: 'web',
  },
  {
    name: 'notfound',
    path: '/notfound',
  }
]

export default routes